import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { APP_VERSION } from '@/version';

const AuthLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: isMobile
          ? '#fff'
          : 'linear-gradient(135deg, #1A365D 0%, #2A4A7F 50%, #3182CE 100%)',
        px: isMobile ? 1 : 0,
      }}
    >
      <Container maxWidth="sm" sx={{ px: isMobile ? 0 : 'auto' }}>
        <Paper
          elevation={isMobile ? 0 : 8}
          sx={{
            p: isMobile ? 2 : 4,
            borderRadius: isMobile ? 0 : 3,
            textAlign: 'center',
          }}
        >
          {/* 左上角软件品牌标：芸胞 yuncell */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 1, mb: 2 }}>
            <Box
              component="img"
              src="/logo-icon.svg"
              alt="芸胞 yuncell"
              sx={{ height: isMobile ? 24 : 28 }}
            />
            <Typography sx={{ fontWeight: 700, color: '#0E7490', fontSize: isMobile ? 16 : 18 }}>
              芸胞™
            </Typography>
          </Box>

          {/* 主标题：咨询品牌出品背书 */}
          <Typography variant={isMobile ? 'h5' : 'h4'} sx={{ color: '#1A365D', mb: 1, fontWeight: 700 }}>
            芸芸向上® 出品
          </Typography>

          <Outlet />

          {/* 底部版权 */}
          <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #eee' }}>
            <Typography variant="caption" sx={{ color: '#999', display: 'block', lineHeight: 1.8 }}>
              © 2021-2026 广州云包公网络科技有限公司
            </Typography>
            <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>
              芸胞™ v{APP_VERSION}
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default AuthLayout;
